import axios from "axios";
import { API_URL } from "../config/Constants";
import { CommonContent, Language, Content } from "../types/Types";

const instance = axios.create({
  baseURL: API_URL,
  timeout: 30000,
});

const getCommonContent = (lan: Language) => {
  return instance.get<CommonContent[]>(`/api/v1/content/common?lang=${lan}`);
};

const getContent = (lan: Language) => {
  return instance.get<Content[]>(`/api/v1/content/?lang=${lan}`);
};

export default {
  getCommonContent,
  getContent,
};
